import BasicResource from '@/api/resource';

class TspResource extends BasicResource {

    constructor () {
        super('verify');
    }

    get (id, params, options) {
        return this.client.request ({
            method: 'get',
            path: `/email/verify/${id}`,
            params,
        }, options);
    }
}

export default new TspResource;
